export const SETUP_COMPLETED = 'SETUP_COMPLETED';

export const SET_CUSTOMER_ID = 'SET_CUSTOMER_ID';

export const SET_DISPLAY_NAME = 'SET_DISPLAY_NAME';

export const SET_IS_PERMANENT_REMOTE_PAIRED = 'SET_IS_PERMANENT_REMOTE_PAIRED';

export const SET_IS_SPOT = 'SET_IS_SPOT';

export const SET_JWT = 'SET_JWT_TOKEN';

export const SET_PREFERRED_DEVICES = 'SET_PREFERRED_DEVICES';

export const SET_PREFERRED_RESOLUTION = 'SET_PREFERRED_RESOLUTION';

export const SET_ROOM_ID = 'SET_ROOM_ID';

export const SET_TENANT = 'SET_TENANT';
